export const SOUND = {
  // notification:
  //   'https://antoree-assets.s3.ap-southeast-1.amazonaws.com/audio_message.mp3',
  notification:
    // 'https://antoree-assets.s3.ap-southeast-1.amazonaws.com/audio_message_2.mp3',
    // 'https://s3.ap-southeast-1.amazonaws.com/files.antoree.com/sound_notifications/tic_tic_sound_notification.mp3',
    'https://s3.ap-southeast-1.amazonaws.com/files.antoree.com/sound_notifications/positive_notification-951.wav',
};
